import React, { useContext } from 'react';
import CardDisplayModel from 'models/CardDisplayModel';
import CardDataModel from 'models/CardDataModel';

interface IMiniCardContext {
  data: CardDataModel;
  display: CardDisplayModel;
}

const MiniCardContext = React.createContext({} as IMiniCardContext);

export const _useMiniCardHook = (): IMiniCardContext => {
  return useContext(MiniCardContext);
};

export const MiniCardProvider = ({ children, value }: any) => {
  return <MiniCardContext.Provider value={value}>{children}</MiniCardContext.Provider>;
};
